module.exports = __webpack_public_path__ + "img/6.32894319.jpg";